import React, { useEffect, useState } from "react";
import { verificarStatusPagamento } from "../../../API/service";

const PixPaymentStatus = ({ transactionId, onPaymentSuccess }) => {
  const [status, setStatus] = useState("pending");
  const [error, setError] = useState(null);

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        // 🔹 Consulta o status no backend
        const response = await verificarStatusPagamento(transactionId);
        const rawStatus =
          typeof response === "string"
            ? response
            : response?.status || "unknown";

        console.log("📡 Status retornado do backend:", rawStatus);

        // 🔹 Normaliza o status (ASAAS + Mercado Pago)
        const statusMap = {
          approved: "paid", // Mercado Pago
          confirmed: "paid", // ASAAS
          received: "paid", // ASAAS Pix recebido
          pending: "pending", // ASAAS & Mercado Pago
          in_process: "pending",
          awaiting: "pending",
          failed: "error",
          refused: "error",
          cancelled: "error",
          error: "error",
        };

        const normalized =
          statusMap[rawStatus.toLowerCase()] || "pending";

        setStatus(normalized);

        // 🔹 Pagamento confirmado
        if (normalized === "paid") {
          clearInterval(interval);
          onPaymentSuccess?.();
        }
      } catch (err) {
        console.error("❌ Erro ao verificar status do pagamento:", err);
        setError("Erro ao atualizar status do pagamento.");
      }
    }, 5000); // a cada 5 segundos

    return () => clearInterval(interval);
  }, [transactionId, onPaymentSuccess]);

  return (
    <div style={{ textAlign: "center", marginTop: "1rem" }}>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {status === "pending" && (
        <p style={{ color: "#777" }}>Aguardando confirmação do pagamento ⏳</p>
      )}
      {status === "paid" && (
        <p style={{ color: "green" }}>Pagamento confirmado ✅</p>
      )}
      {status === "error" && (
        <p style={{ color: "red" }}>Erro no pagamento ❌</p>
      )}
    </div>
  );
};

export default PixPaymentStatus;
